import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
    selector: 'fbr-history-entry-detail',
    templateUrl: './history-entry-detail.component.html',
    styleUrls: ['./history-entry-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HistoryEntryDetailComponent {}
